import { render, staticRenderFns } from "./wizard-store-update-history.vue?vue&type=template&id=573fb8b4&scoped=true"
import script from "./wizard-store-update-history.vue?vue&type=script&lang=ts"
export * from "./wizard-store-update-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fb8b4",
  null
  
)

export default component.exports